import React from 'react';
import { styles, colors } from '../../styles/styles';

const IntentionInput = ({ 
    value, 
    availableIntentions, 
    showDropdown, 
    onInputChange, 
    onKeyPress, 
    onFocus, 
    onBlur, 
    onIntentionSelect,
    onClear 
}) => {
    // Filter intentions based on input value
    const filteredIntentions = value.trim() === '' 
        ? [...availableIntentions].sort((a, b) => a.localeCompare(b)) // Show all alphabetically when empty
        : availableIntentions.filter(intention =>
            intention.toLowerCase().includes(value.toLowerCase())
          ).sort((a, b) => a.localeCompare(b)); // Filter and sort when typing

    return (
        <div style={{ position: 'relative' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                    type="text"
                    value={value}
                    onChange={(e) => onInputChange(e.target.value)}
                    onKeyPress={onKeyPress}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    placeholder="Enter intention..."
                    style={{
                        ...styles.input,
                        borderColor: '#E5E9EF',
                        flex: 1,
                    }}
                />
                {value && (
                    <button
                        onClick={onClear}
                        style={{
                            backgroundColor: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            padding: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        title="Clear intention"
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18" stroke={colors.textSecondary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M6 6L18 18" stroke={colors.textSecondary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                )}
            </div>
            
            {/* Dropdown */}
            {showDropdown && availableIntentions.length > 0 && (
                <div style={{
                    ...styles.autocomplete,
                    animationName: 'fadeIn',
                    animationDuration: '0.2s'
                }}>
                    {filteredIntentions.map((intention, index) => (
                        <div
                            key={index}
                            onMouseDown={(e) => {
                                e.preventDefault(); // Prevent blur
                                onIntentionSelect(intention);
                            }}
                            style={{
                                ...styles.autocompleteItem,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <span>{intention}</span>
                            <span style={{
                                fontSize: '12px',
                                padding: '2px 6px',
                                borderRadius: '4px',
                                backgroundColor: 'rgba(0, 122, 255, 0.1)',
                                color: '#007AFF'
                            }}>
                                Select
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default IntentionInput; 